const initialState = {
  success: false,
  loading: false,
  error: null,
  localities: {
    data: null,
    loading: false,
    error: null,
  },
  admins: {
    data: null,
    loading: false,
    error: null,
  },
  districts: {
    data: null,
    loading: false,
    error: null,
  },
  mouzas: {
    data: null,
    loading: false,
    error: null,
  },
  highways: {
    data: null,
    loading: false,
    error: null,
  },
  circles: {
    data: null,
    loading: false,
    error: null,
  },
  localityCodes: {
    data: null,
    loading: false,
    error: null,
  },
  wards: {
    data: null,
    loading: false,
    error: null,
  },
  blocks: {
    data: null,
    loading: false,
    error: null,
  },
  inspectors: {
    data: null,
    loading: false,
    error: null,
  },
  etoCircles: {
    data: null,
    loading: false,
    error: null,
  },
  etoZones: {
    data: null,
    loading: false,
    error: null,
  },
  zones: {
    data: null,
    loading: false,
    error: null,
  },
  users: {
    data: null,
    loading: false,
    error: null,
  },
  circlesInZone: {
    data: null,
    loading: false,
    error: null,
  },
  circlesOrZones: {
    data: null,
    loading: false,
    error: null,
  },
  userByZoneOrCircle: {
    data: null,
    loading: false,
    error: null,
  },

  tisInCircle: {
    data: [],
    loading: false,
    error: null,
  },
  banks: {
    data: [],
    loading: false,
    error: null,
  },
  branches: {
    data: [],
    loading: false,
    error: null,
  },

  propertyTypes: [],
  propertyClassifications: [],
  buildingTypes: [],
};

const dropDownReducer = (
  state = initialState,
  { obj, type, error, payload, data, pagination }
) => {
  switch (type) {
    case "RESET_DROPDOWNS":
      return initialState;
    case "GET_ADMINS":
      return {
        ...state,
        type,
        error: null,
        admins: {
          ...initialState.admins,
          loading: true,
        },
      };

    case "GET_ADMINS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        admins: {
          ...state.admins,
          loading: false,
          data: data.data,
        },
      };
    case "GET_ADMINS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        admins: {
          ...state.mouzas,
          loading: false,
          error,
        },
      };
    case "GET_HIGHWAYS":
      return {
        ...state,
        type,
        error: null,
        highways: {
          ...initialState.highways,
          loading: true,
        },
      };

    case "GET_HIGHWAYS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        highways: {
          ...state.highways,
          loading: false,
          data: data.data,
        },
      };
    case "GET_HIGHWAYS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        highways: {
          ...state.mouzas,
          loading: false,
          error,
        },
      };
    case "GET_MOUZAS":
      return {
        ...state,
        type,
        error: null,
        mouzas: {
          ...initialState.mouzas,
          loading: true,
        },
      };

    case "GET_MOUZAS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        mouzas: {
          ...state.mouzas,
          loading: false,
          data: data.data,
        },
      };
    case "GET_MOUZAS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        mouzas: {
          ...state.mouzas,
          loading: false,
          error,
        },
      };

    case "GET_CIRCLES":
      return {
        ...state,
        type,
        error: null,
        circles: {
          ...initialState.circles,
          loading: true,
        },
      };

    case "GET_CIRCLES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        circles: {
          ...state.circles,
          loading: false,
          data: data.data,
        },
      };
    case "GET_CIRCLES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        circles: {
          ...state.circles,
          loading: false,
          error,
        },
      };
    case "GET_DISTRICTS":
      return {
        ...state,
        type,
        error: null,
        districts: {
          ...state.districts,
          loading: true,
        },
      };

    case "GET_DISTRICTS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        districts: {
          ...state.districts,
          loading: false,
          data: data.data,
        },
      };
    case "GET_DISTRICTS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        districts: {
          ...state.districts,
          loading: false,
          error,
        },
      };
    case "GET_LOCALITIES":
      return {
        ...state,
        type,
        error: null,
        localities: {
          ...initialState.localities,
          loading: true,
        },
      };

    case "GET_LOCALITIES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        localities: {
          ...state.localities,
          loading: false,
          data: data.data,
        },
        localityCodes: {
          ...state.localityCodes,
          data: null,
        },
        blocks: {
          ...state.blocks,
          data: null,
        },
        wards: {
          ...state.wards,
          data: null,
        },
      };

    case "GET_LOCALITIES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        localities: {
          ...state.localities,
          loading: false,
          error,
        },
      };

    case "GET_LOCALITY_CODES":
      return {
        ...state,
        type,
        error: null,
        localityCodes: {
          ...initialState.localityCodes,
          loading: true,
        },
      };

    case "GET_LOCALITY_CODES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        localityCodes: {
          ...state.localityCodes,
          loading: false,
          data: data.data,
        },
        blocks: {
          ...state.blocks,
          data: null,
        },
        wards: {
          ...state.wards,
          data: null,
        },
      };

    case "GET_LOCALITY_CODES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        localityCodes: {
          ...state.localityCodes,
          loading: false,
          error,
        },
      };

    case "GET_WARDS":
      return {
        ...state,
        type,
        error: null,
        wards: {
          ...initialState.wards,
          loading: true,
        },
      };

    case "GET_WARDS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        wards: {
          ...state.wards,
          loading: false,
          data: data.data,
        },
        blocks: {
          ...state.wards,
          data: null,
        },
      };

    case "GET_WARDS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        wards: {
          ...state.wards,
          loading: false,
          error,
        },
      };

    case "GET_BLOCKS":
      return {
        ...state,
        type,
        error: null,
        blocks: {
          ...initialState.blocks,
          loading: true,
        },
      };

    case "GET_BLOCKS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        blocks: {
          ...state.blocks,
          loading: false,
          data: data.data,
        },
      };

    case "GET_BLOCKS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        blocks: {
          ...state.blocks,
          loading: false,
          error,
        },
      };

    case "GET_BUILDING_TYPES":
      return {
        ...state,
        loading: true,
        type,
        error: null,
        buildingTypes: initialState.buildingTypes,
      };

    case "GET_BUILDING_TYPES_SUCCESS":
      return {
        ...state,
        loading: false,
        payload,
        buildingTypes: data.data,
      };

    case "GET_BUILDING_TYPES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
      };

    case "GET_PROPERTY_TYPES":
      return {
        ...state,
        loading: true,
        type,
        error: null,
        propertyTypes: initialState.propertyTypes,
      };

    case "GET_PROPERTY_TYPES_SUCCESS":
      return {
        ...state,
        loading: false,
        payload,
        propertyTypes: data.data,
      };

    case "GET_PROPERTY_TYPES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
      };
    case "GET_PROPERTY_CLASSIFICATIONS":
      return {
        ...state,
        loading: true,
        type,
        error: null,
        propertyClassifications: initialState.propertyClassifications,
      };

    case "GET_PROPERTY_CLASSIFICATIONS_SUCCESS":
      return {
        ...state,
        loading: false,
        payload,
        propertyClassifications: data.data,
      };

    case "GET_PROPERTY_CLASSIFICATIONS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
      };
    case "GET_INSPECTORS":
      return {
        ...state,
        type,
        error: null,
        inspectors: {
          ...initialState.inspectors,
          loading: true,
        },
      };

    case "GET_INSPECTORS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        inspectors: {
          ...state.inspectors,
          loading: false,
          data: data.data,
        },
      };
    case "GET_INSPECTORS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        inspectors: {
          ...state.inspectors,
          loading: false,
        },
      };
    case "GET_ETO_CIRCLES":
      return {
        ...state,
        type,
        error: null,
        etoCircles: {
          ...initialState.etoCircles,
          loading: true,
        },
      };

    case "GET_ETO_CIRCLES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        etoCircles: {
          ...state.etoCircles,
          loading: false,
          data: data.data,
        },
      };
    case "GET_ETO_CIRCLES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        etoCircles: {
          ...state.etoCircles,
          loading: false,
        },
      };
    case "GET_ZONES":
      return {
        ...state,
        type,
        error: null,
        zones: {
          ...initialState.zones,
          loading: true,
        },
      };

    case "GET_ZONES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        zones: {
          ...state.zones,
          loading: false,
          data: data.data,
        },
      };
    case "GET_ZONES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        zones: {
          ...state.zones,
          loading: false,
        },
      };

    case "GET_USER_BY_ZONE_OR_CIRCLE":
      return {
        ...state,
        type,
        error: null,
        userByZoneOrCircle: {
          ...initialState.userByZoneOrCircle,
          loading: true,
        },
      };

    case "GET_USER_BY_ZONE_OR_CIRCLE_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        userByZoneOrCircle: {
          ...state.userByZoneOrCircle,
          loading: false,
          data: data.data,
        },
      };
    case "GET_USER_BY_ZONE_OR_CIRCLE_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        userByZoneOrCircle: {
          ...state.userByZoneOrCircle,
          loading: false,
        },
      };
    case "GET_USERS":
      return {
        ...state,
        type,
        error: null,
        users: {
          ...initialState.users,
          loading: true,
        },
      };

    case "GET_USERS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        users: {
          ...state.users,
          loading: false,
          data: data.data,
        },
      };
    case "GET_USERS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        users: {
          ...state.users,
          loading: false,
        },
      };
    case "GET_ETO_ZONES":
      return {
        ...state,
        type,
        error: null,
        etoZones: {
          ...initialState.etoZones,
          loading: true,
        },
      };

    case "GET_ETO_ZONES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        etoZones: {
          ...state.etoZones,
          loading: false,
          data: data.data,
        },
      };
    case "GET_ETO_ZONES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        etoZones: {
          ...state.etoZones,
          loading: false,
        },
      };
    case "GET_CIRCLES_BY_ZONE":
      return {
        ...state,
        type,
        error: null,
        circlesInZone: {
          ...initialState.circlesInZone,
          loading: true,
        },
      };

    case "GET_CIRCLES_BY_ZONE_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        circlesInZone: {
          ...state.circlesInZone,
          loading: false,
          data: data.data,
        },
      };
    case "GET_CIRCLES_BY_ZONE_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        circlesInZone: {
          ...state.circlesInZone,
          loading: false,
        },
      };

    case "GET_TIS_BY_CIRCLE":
      return {
        ...state,
        tisInCircle: {
          ...initialState.tisInCircle,
          loading: true,
        },
      };

    case "GET_TIS_BY_CIRCLE_SUCCESS":
      return {
        ...state,
        tisInCircle: {
          ...state.tisInCircle,
          loading: false,
          data: data.data,
        },
      };
    case "GET_TIS_BY_CIRCLE_FAIL":
      return {
        ...state,
        tisInCircle: {
          ...state.tisInCircle,
          loading: false,
          error,
        },
      };
    case "GET_BANKS":
      return {
        ...state,
        banks: {
          ...initialState.banks,
          loading: true,
        },
      };

    case "GET_BANKS_SUCCESS":
      return {
        ...state,
        banks: {
          ...state.banks,
          loading: false,
          data: data.data,
        },
      };
    case "GET_BANKS_FAIL":
      return {
        ...state,
        banks: {
          ...state.banks,
          loading: false,
          error,
        },
      };
    case "GET_BRANCHES":
      return {
        ...state,
        branches: {
          ...initialState.branches,
          loading: true,
        },
      };

    case "GET_BRANCHES_SUCCESS":
      return {
        ...state,
        branches: {
          ...state.branches,
          loading: false,
          data: data.data,
        },
      };
    case "GET_BRANCHES_FAIL":
      return {
        ...state,
        branches: {
          ...state.branches,
          loading: false,
          error,
        },
      };
    case "GET_CIRCLE_OR_ZONE_OF_DISTRICT":
      return {
        ...state,
        circlesOrZones: {
          ...initialState.circlesOrZones,
          loading: true,
        },
      };

    case "GET_CIRCLE_OR_ZONE_OF_DISTRICT_SUCCESS":
      return {
        ...state,
        circlesOrZones: {
          ...state.circlesOrZones,
          loading: false,
          data: data,
        },
      };
    case "GET_CIRCLE_OR_ZONE_OF_DISTRICT_FAIL":
      return {
        ...state,
        circlesOrZones: {
          ...state.circlesOrZones,
          loading: false,
          error,
        },
      };
    default:
      return state;
  }
};

export default dropDownReducer;
